<template lang="pug">
    main
        section
            .title
            .p1 仅通过移动手机端购买
            .p2 请使用爱羽客app或者微信等扫一扫购买
            .qrcode
                img(:src="qrcode")
            .btn-row
                a(href="javascript:;") 我知道啦
</template>

<script>
export default {
    data () {
        return {
            qrcode: window.server.url
        };
    },
    components: {}
};
</script>

<style lang="scss" scoped>
main {
    section {
        width: 380px;
        margin: 0 auto;
        text-align: center;
        background-color: #fff;
        padding: 45px 0;
        .title {
            background-image: url(../../../images/group-buying/groupbuying-icon.png);
            background-size: 216px 42px;
            width: 216px;
            height: 42px;
            margin: 0 auto;
            margin-bottom: 23px;
        }
        .p1 {
            margin-bottom: 12px;
            font-size: 18px;
            color: #000;
        }
        .p2 {
            margin-bottom: 33px;
            font-size: 14px;
            color: #000;
        }
        .qrcode {
            img {
                width: 200px;
                height: 200px;
            }
            margin-bottom: 36px;
        }
        .btn-row {
            width: 200px;
            margin: 0 auto;
            a {
                display: block;
                font-size: 18px;
                color: #fff;
                background-color: #0cb25e;
                height: 40px;
                line-height: 40px;
                border-radius: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/js_modules/vue/components/groupBuyingJump.vue